import { apiFetch } from '@/lib/api/http';

import type { EventItem } from '@/features/events/api';

/** サクセス担当の実施可能日と、面談日程の確定（D-183）. */
export interface AvailabilitySlot {
  id: string;
  starts_at: string;
  ends_at: string;
  /** 受講生が選択済みなら入る（選択済みの枠は取り消せない） */
  claimed_at: string | null;
  event_id: string | null;
}

export function fetchMySlots(): Promise<AvailabilitySlot[]> {
  return apiFetch<AvailabilitySlot[]>('/availability-slots');
}

export function createSlot(payload: {
  starts_at: string;
  ends_at: string;
  /** 事務局が相手（担当者）の代理で登録するとき指定（D-183） */
  owner_user_id?: string;
}): Promise<AvailabilitySlot> {
  return apiFetch<AvailabilitySlot>('/availability-slots', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function cancelSlot(slotId: string): Promise<void> {
  return apiFetch<void>(`/availability-slots/${slotId}`, { method: 'DELETE' });
}

export interface CandidateSlot {
  id: string;
  starts_at: string;
  ends_at: string;
  owner_name: string | null;
}

export function fetchCandidateSlots(eventId: string): Promise<CandidateSlot[]> {
  return apiFetch<CandidateSlot[]>(`/events/${eventId}/candidate-slots`);
}

export function claimSlot(eventId: string, slotId: string): Promise<EventItem> {
  return apiFetch<EventItem>(`/events/${eventId}/claim-slot`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ slot_id: slotId }),
  });
}
